import React from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
import { SpotifyIcon } from '@/components/icons';
import { Button } from '@/components/ui/button';
import { AnimatedLetters, SectionLabel, WordsPullUp } from '@/components/animations';

const BODY =
  'Set in the world of Midharan, The King Below is a grimdark fantasy novel series written as J. Urbinati. An original soundtrack is already on Spotify. The story is just beginning.';

export const KingBelowCard = ({ active }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    animate={active ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
    transition={{ duration: 1.1, ease: 'easeOut' }}
    className="glass-card-ember w-[min(840px,92vw)] p-7 sm:p-12"
    data-testid="tkb-card"
  >
    <div className="grid grid-cols-1 sm:grid-cols-[220px_1fr] gap-8 items-center">
      <a
        href="https://www.goodreads.com/book/show/239818655-the-king-below"
        target="_blank"
        rel="noopener noreferrer"
        className="group relative mx-auto block w-44 sm:w-full aspect-[2/3] overflow-hidden rounded-xl border border-ember/30 bg-abyss shadow-[0_30px_80px_-30px_hsl(var(--ember)/0.6)] transition-transform duration-300 hover:-translate-y-1"
        data-testid="tkb-cover"
        aria-label="The King Below — view on Goodreads"
      >
        <img
          src={`${process.env.PUBLIC_URL || ''}/tkb-cover.jpg`}
          alt="The King Below book cover"
          className="absolute inset-0 h-full w-full object-cover"
          loading="lazy"
        />
        <div className="absolute bottom-0 inset-x-0 h-16 bg-gradient-to-t from-ember/20 to-transparent animate-ember-breathe" />
      </a>

      <div className="flex flex-col">
        <SectionLabel ember>The Novel</SectionLabel>
        <h2 className="font-display text-4xl sm:text-5xl text-cream-warm leading-tight font-normal">
          <WordsPullUp text="The King Below." active={active} />
        </h2>
        <p className="mt-2 font-serif italic text-xl sm:text-2xl text-cream-warm/75">A dark fantasy decade in the making.</p>
        <AnimatedLetters text={BODY} className="mt-6 text-sm sm:text-base leading-relaxed text-muted-foreground" />
        <div className="mt-8 flex flex-wrap gap-3">
          <Button asChild variant="emberPill" size="pill" data-testid="tkb-instagram-btn">
            <a href="https://instagram.com/thekingbelow" target="_blank" rel="noopener noreferrer">
              <Instagram />
              Follow @thekingbelow
            </a>
          </Button>
          <Button asChild variant="emberPill" size="pill" data-testid="tkb-spotify-btn">
            <a href="https://open.spotify.com/search/the%20king%20below" target="_blank" rel="noopener noreferrer">
              <SpotifyIcon className="h-4 w-4" />
              Listen on Spotify
            </a>
          </Button>
        </div>
      </div>
    </div>
  </motion.div>
);
